import type { FunctionComponent } from "react";
import { useMemo } from "react";

import styled from "styled-components";

import { percentageFilter } from "app/filters/ngFilters";
import Chart from "pro-features/components/Chart/src/Chart";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { formatGenderPieChartData, getGenderPieChartConfig, getGenderPieChartStyle } from "./genderPiechartConfig";

interface IGenderDistributionPieChartProps {
    malePercent: number;
    femalePercent: number;
}

const GenderChartContainer = styled(FlexColumn)`
    width: 100%;
    height: 100%;
`;

export const GenderDistributionPieChart: FunctionComponent<IGenderDistributionPieChartProps> = (props) => {
    const { malePercent, femalePercent } = props;

    const { chartConfig, chartStyle } = useMemo(() => {
        return {
            chartConfig: getGenderPieChartConfig({ type: "pie", filter: percentageFilter }),
            chartStyle: getGenderPieChartStyle(),
        };
    }, []);

    const chartData = useMemo(() => {
        return formatGenderPieChartData(malePercent, femalePercent);
    }, [malePercent, femalePercent]);

    return (
        <GenderChartContainer>
            <Chart
                type={"pie"}
                config={chartConfig}
                data={chartData}
                domProps={chartStyle}
            />
        </GenderChartContainer>
    );
};
